export default function Configure($stateProvider) {
	$stateProvider.state('chauffeurs', {
		parent: 'common',
		url: '/chauffeurs',
		//abstract: true,
		views: {
			common: {
				template: '<ui-view></ui-view>'
			}
		},
		ncyBreadcrumb: {
			// le state étant parent et abstract, on décide de ne pas l'afficher dans le fil d'ariane
			//skip: true
			label: '{{ "LAYOUT.NAVIGATION.TRANSPORT" | translate }}'
		}
	});

	$stateProvider.state('chauffeurs.list', {
		url: '/:genre/list',
		template: '<personnes></personnes>',
		rights: { domain: 'chauffeurs', right: 'read' },
		ncyBreadcrumb: {
			parent: 'chauffeurs',
			label: '{{ "PERSONNES.BREADCRUMBS.CHAUFFEURS_LIST" | translate}}'
		},
		// // on affiche la liste des personnes dans la navigation
		// navigation: {
		//     menu: 'donnees_parametres_donnees',
		//     translate: 'PERSONNES.BREADCRUMBS.PERSONNES_LIST'
		// },
		// // la liste des personnes fait partie des points d'entrée recherchables dans la navigation
		search: 'PERSONNES.BREADCRUMBS.CHAUFFEURS_LIST'
	});

	$stateProvider.state('chauffeurs.list.detail', {
		url: '/{id}',
		template: '<personne-detail></personne-detail>',
		//rights: {domain: 'chauffeurs', right: 'read'},
		ncyBreadcrumb: {
			parent: 'chauffeurs.list',
			label: '{{ "PERSONNES.BREADCRUMBS.CHAUFFEUR_DETAIL" | translate }}'
		}
	});

	$stateProvider.state('chauffeurs.new', {
		url: '/:genre/new',
		template: '<personnes-form></personnes-form>',
		rights: { domain: 'chauffeurs', right: 'create' },
		ncyBreadcrumb: {
			// on décide que la liste est le parent des autres states
			// afin d'afficher personnes > ajouter
			parent: 'chauffeurs.list({genre: "chauffeur"})',
			label: '{{ "PERSONNES.BREADCRUMBS.CHAUFFEUR_NEW" | translate}}'
		},
		params: {
			fromAdminPortail: false
		},
		// l'ajout d'un arret fait partie des points d'entrée recherchables dans l'application
		search: 'PERSONNES.BREADCRUMBS.PERSONNE_NEW'
	});

	$stateProvider.state('chauffeurs.edit', {
		url: '/:genre/{id}/edit',
		template: '<personnes-form></personnes-form>',
		rights: { domain: 'chauffeurs', right: 'update' },
		ncyBreadcrumb: {
			// on décide que la liste est le parent des autres states
			// afin d'afficher personnes > modifier
			parent: 'chauffeurs.list({genre: "chauffeur"})',
			label: '{{ "PERSONNES.BREADCRUMBS.CHAUFFEUR_EDIT" | translate }}'
		},
		params: {
			fromAdminPortail: false
		}
	});

	/*$stateProvider.state('chauffeurs.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: {domain: 'types', right: 'create'},
        params: {parentState:'chauffeurs.new'},
        ncyBreadcrumb: {
            parent: 'chauffeurs.new({genre: "chauffeur"})',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });*/
}

Configure.$inject = ['$stateProvider'];
